import { render, staticRenderFns } from "./IFrameWrapper.vue?vue&type=template&id=0c3710d6&scoped=true"
import script from "./IFrameWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./IFrameWrapper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IFrameWrapper.vue?vue&type=style&index=0&id=0c3710d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3710d6",
  null
  
)

export default component.exports